import React, { useState } from 'react';
import './BusinessModelFirst.css';
import Title from '../../components/Title/Title';

import image1 from '../../assets/20.webp';
import image2 from '../../assets/23.webp';
import image4 from '../../assets/25.webp';
import image5 from '../../assets/31.webp';
import image6 from '../../assets/32.webp';
import image7 from '../../assets/37.webp';
import image8 from '../../assets/41.webp';
import image9 from '../../assets/4.webp';
import image10 from '../../assets/5.webp';
import image11 from '../../assets/40.webp';

interface ModalProps {
  src: string;
  alt: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ src, alt, onClose }) => (
  <div className="business-model-first-modal" onClick={onClose}>
    <img src={src} alt={alt} className="business-model-first-modal-image" onClick={(e) => e.stopPropagation()} />
  </div>
);

const BusinessModelFirst: React.FC = () => {
  const [modalImage, setModalImage] = useState<string | null>(null);

  const openModal = (src: string) => setModalImage(src);
  const closeModal = () => setModalImage(null);

  return (
    <div className="business-model-first">
      <div className="business-model-first-content">
        <div className="business-model-first-title">
          <Title 
            animated="Styropor und Airpop"
            static="Anwendungen, Lebenszyklus und unser Recycling-Prozess"
          />
        </div>
        <div className="business-model-first-process">
          <div className="business-model-first-main-applications">
            <section className="business-model-first-section">
              <h2 className="business-model-first-subtitle">Wärmedämmung und Isolierung</h2>
              <p className="business-model-first-text">
                Styropor-Airpop findet breite Anwendung in der Wärmedämmung und Isolierung an und in Gebäuden.
                Als Fassadendämmung, Dachdämmung oder Perimeterdämmung schützt EPS zuverlässig vor Wärmeverlust.
                Nach dem Rückbau oder der Sanierung fällt dieses Material in großen Mengen an.
                Häufig ist es mit Putz, Kleber oder HBCD-Flammschutzmitteln belastet, was die Entsorgung erschwert – Isolierung Recycling ist unser Fachgebiet.
              </p>
              <div className="business-model-first-image-container business-model-first-image-container-1">
                <img src={image1} alt="Styropor Wärmedämmung an Gebäudefassade in Hamburg" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image1)} />
                <img src={image2} alt="EPS Isolierung für Gebäudedämmung" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image2)} />
              </div>
            </section>
            <section className="business-model-first-section">
              <h2 className="business-model-first-subtitle">EPS Transportverpackung</h2>
              <p className="business-model-first-text">
                Expandiertes Styropor dient als Transportverpackung für unzählige Artikel des täglichen modernen Lebens.
                Von Elektrogeräten über Möbel bis hin zu empfindlichen Lebensmitteln – EPS-Verpackungen schützen Produkte
                zuverlässig beim Transport. Diese Verpackungen machen einen erheblichen Anteil des anfallenden Polystyrol-Abfalls aus.
              </p>
              <div className="business-model-first-image-container business-model-first-image-container-1">
                <img src={image4} alt="EPS Transportverpackung für Elektrogeräte" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image4)} />
                <img src={image5} alt="Expandiertes Styropor als Schutzverpackung" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image5)} />
              </div>
            </section>
            <section className="business-model-first-section">
              <h2 className="business-model-first-subtitle">Branchenspezifische Styropor-Anwendungen</h2>
              <p className="business-model-first-text">
                Polystyrol und EPS finden vielfältige Einsatzmöglichkeiten in verschiedenen Branchen.
                In der Lebensmittelindustrie, im Gartenbau, im Messebau und in der Logistik ist Styropor
                ein unverzichtbarer Werkstoff. Allein in Deutschland fallen jährlich hunderttausende Tonnen
                EPS-Abfall an. Umso wichtiger ist die fachgerechte Verwertung nach Gebrauch.
              </p>
              <div className="business-model-first-image-container business-model-first-image-container-1">
              <img src={image6} alt="Styropor-Anwendung in der Lebensmittelbranche" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image6)} />
                <img src={image8} alt="Polystyrol Verpackungslösungen für die Industrie" loading="lazy" className="business-model-first-image" width={400} height={400} onClick={() => openModal(image8)} />
              </div>
            </section>
          </div>
          <div className="business-model-first-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg>
          </div>
          <div className="business-model-first-lifecycle">
            <section className="business-model-first-section">
              <h2 className="business-model-first-subtitle">Nach Gebrauch: Styropor Entsorgung und Recycling</h2>
              <p className="business-model-first-text">
                Was passiert mit diesem wertvollen Rohstoff nach der Nutzung? Viel zu oft landet Styropor
                unsortiert im Restmüll oder auf der Deponie. Dabei lässt sich Polystyrol hervorragend
                recyceln und dem Produktionskreislauf wieder zuführen. Auch HBCD-belastetes Styropor, das als
                gefährlicher Abfall eingestuft wird, kann fachgerecht entsorgt und verwertet werden – genau
                das ist unsere Aufgabe bei StyroR.
              </p>
              <div className="business-model-first-image-container business-model-first-image-container-16-9">
                <img src={image9} alt="Styropor Abfall vor der fachgerechten Entsorgung" loading="lazy" className="business-model-first-image" width={640} height={360} onClick={() => openModal(image9)} />
                <img src={image10} alt="EPS Recycling – Styropor nach Gebrauch" loading="lazy" className="business-model-first-image" width={640} height={360} onClick={() => openModal(image10)} />
              </div>
            </section>
          </div>
        </div>
      </div>
      {modalImage && (
        <Modal src={modalImage} alt="Styropor Recycling – Detailansicht" onClose={closeModal} />
      )}
    </div>
  );
};

export default BusinessModelFirst;